import React from "react";
import * as S from './OwnerDetailsStyles';
import StarRating from '../StarRating/StarRating';

const OwnerDetails = ({
    data
}) => {
  const {
      img,
      name,
      ratingVal,
      label,
      subLabel
  } = data || {};

  return (
    <S.OwnerDetails>
      { img && <S.OwnerImage src={img}/> }
      <div>
          <S.LabelWrapper>
              { name && <S.Name>{name}</S.Name> }
              { label && <S.Label className="label">{label}</S.Label> }
              { ratingVal && <StarRating value={ratingVal} /> }
          </S.LabelWrapper>
          { subLabel && <S.SubLabel>{subLabel}</S.SubLabel> }
      </div>
    </S.OwnerDetails>
  );
};

export default OwnerDetails;